module.exports = __webpack_public_path__ + "img/buttonCamera.383e7c39.svg";